var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.artwork.imagePreviewUrl,"alt":_vm.artwork.name},on:{"click":_vm.setAuctionModal}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c316a7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/internet_auctions/components/artwork/artwork_image.vue
// module id = 616
// module chunks = 0 1 2 3 4 5 6 7 8 10 15 19 30 36 320